export function useAppDirection() {
  const { $getLocale } = useI18n()

  const rtlLocales = ['ar', 'he', 'fa', 'ur']

  const lang = computed(() => $getLocale())

  const isRtl = computed(() => {
    return rtlLocales.includes(lang.value)
  })

  const dir = computed(() => {
    return isRtl.value ? 'rtl' : 'ltr'
  })

  const sidebarSide = computed<'left' | 'right'>(() => {
    return isRtl.value ? 'right' : 'left'
  })

  return {
    lang,
    dir,
    isRtl,
    sidebarSide
  }
}
